import { DocumentNode } from '@apollo/client'
import { WAVES } from '../modules/Project/Project.query'
import { useOptionalWaveId } from './useOptionalWaveId'

/**
 * Queries to refetch after a market's state changes, besides the project ones.
 * `waves` lists each wave's market states, but Wave and Survey aren't
 * normalised in the cache, so nothing else updates them. Only wave routes
 * query it, so elsewhere there is nothing to refetch.
 */
export const useWavesRefetchQueries = (): DocumentNode[] =>
  useOptionalWaveId() ? [WAVES] : []
